import type { ReactNode } from 'react'

export type SelectChipPreviewState = 'default' | 'selected' | 'open'

export type SelectChipOption = {
  id: string
  label: string
}

export type SelectChipProps = {
  /** Chip label shown when idle (e.g. "Title"). */
  label: string
  options: SelectChipOption[]
  value?: string | null
  defaultValue?: string | null
  onChange?: (id: string | null) => void
  /** Optional leading icon. Defaults to a plus. */
  icon?: ReactNode
  /**
   * Count shown after the label when active, e.g. "Title (1)".
   * Defaults to 1 when a value is selected.
   */
  count?: number
  darkMode?: boolean
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
  previewState?: SelectChipPreviewState
  disabled?: boolean
  className?: string
  ariaLabel?: string
}

export const SELECT_CHIP_PREVIEW_STATES: SelectChipPreviewState[] = [
  'default',
  'selected',
  'open',
]

export const SELECT_CHIP_PREVIEW_STATE_LABELS: Record<
  SelectChipPreviewState,
  string
> = {
  default: 'Default',
  selected: 'Selected',
  open: 'Open',
}

export const SELECT_CHIP_DEMO_OPTIONS: SelectChipOption[] = [
  { id: 'item-1', label: 'Item 1' },
  { id: 'item-2', label: 'Item 2' },
  { id: 'item-3', label: 'Item 3' },
  { id: 'item-4', label: 'Item 4' },
]
